<template>
    <li>
        <a :href="cafeUrl" target="_blank" class="item_fancafe_top">
            <span class="num_item">
                {{ currRank }}
                <span class="info_change type_up" v-if="rankDiff > 0"><span class="ico_cafetop ico_up">상승</span>{{ rankDiff }}</span>
                <span class="info_change" v-else-if="rankDiff < 0"><span class="ico_cafetop ico_down">하락</span>{{ Math.abs(rankDiff) }}</span>
                <span class="info_change" v-else><span class="ico_cafetop ico_stay">유지</span></span>
            </span>
            <span class="fancafe_linknail">
                <div class="thumb_g">
                    <img :src="imageUrl" width="350" height="210" alt="">
                </div>
            </span>
            <div class="box_item" v-if="tab === 'fandom'">
                <strong class="tit_item"><span>{{ starName }}</span></strong>
                <div class="desc_item">
                    <ul class="list_data">
                        <li class="txt_cafe">카페 <em>{{ cafeCurrRank }}등</em></li>
                        <li class="txt_cheer">응원 <em>{{ cheerCurrRank }}등</em></li>
                    </ul>
                </div>
            </div>
            <div class="box_item" v-else-if="tab === 'cafe'">
                <strong class="tit_item"><span>{{ starName }}</span></strong>
                <div class="desc_item">
                    <ul class="list_data">
                        <li>방문 <em>{{ visitScore.toLocaleString() }}</em></li>
                        <li>가입 <em>{{ newMemberScore }}</em></li>
                        <li>새글 <em>{{ newArticleScore }}</em></li>
                    </ul>
                    <ul class="list_info">
                        <li v-if="manage">소속사</li>
                        <li v-if="starJoin">스타가입</li>
                    </ul>
                </div>
            </div>
            <div class="box_item" v-else-if="tab === 'cheer'">
                <strong class="tit_item"><span>{{starName}}</span></strong>
                <span class="info_cheer">응원 <em>{{ cheerScore.toLocaleString() }}점</em></span>
            </div>
        </a>
    </li>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        starName: String,

        fandomCurrRank: Number,
        fandomPrevRank: Number,

        cafeCurrRank: Number,
        cafePrevRank: Number,

        cheerCurrRank: Number,
        cheerPrevRank: Number,

        sectionImageUrl: String,
        profileImageUrl: String,
        topRankImageUrl: String,

        grpid: String,
        grpcode: String,
        grpname: String,

        cafeUrl: String,

        visitScore: {
            type: Number,
            default: 0
        },
        newMemberScore: Number,
        newArticleScore: Number,
        official: Boolean,
        starJoin: Boolean,
        manage: Boolean,

        cheerScore: {
            type: Number,
            default: 0
        }
    },
    computed: {
        ...mapState(["tab"]),
        rankDiff() {
            return this[this.tab + "PrevRank"] - this[this.tab + "CurrRank"];
        },
        currRank() {
            return this[this.tab + "CurrRank"];
        },
        imageUrl() {
            const url = "//img1.daumcdn.net/thumb/S700x420/?fname=";
            if(this.topRankImageUrl) return url + this.topRankImageUrl;
            else return url + this.sectionImageUrl;
        }
    }
}
</script>
